/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Input, Switch } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import { useDispatch, useSelector } from 'react-redux';
import { esriFieldsFromObject } from "../actions/portal/esri/esriFieldsFromObject";

const EditLayerForm = (props) => {
  const dispatch = useDispatch();

  const { token } = useSelector(state => state.authReducer);
  const { esriFields } = useSelector(state => state.esriReducer)

  const [checkRan, setCheckRan] = React.useState(false);

  React.useEffect(() => {
    setCheckRan(true);
  }, [esriFields])

  const submit = (event, props, check) => {
    props.onSubmit({ ...event, 
      groups: event.Groups, 
      attribute1: event?.attribute1?.name,
      attribute2: event?.attribute2?.name,
      attribute3: event?.attribute3?.name,
    }, event.Groups);
  }

  const fetchFields = (fetcher) => {
    const data = {
      layerUrl: fetcher('url'),
      tokenUrl: fetcher('tokenUrl'),
      tokenUsername: fetcher('tokenUsername'),
      tokenPassword: fetcher('tokenPassword')
    };
    dispatch(esriFieldsFromObject(data, token));
  }

  const FormMultiSelect = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;

    return (
      <div>
        <MultiSelect
          data={props.groups}
          textField="name"
          dataItemKey="id"
          {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    )
  }

  const FormStringInput = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <Input {...others} />
        {
          visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
        }
      </div>
    );
  };

  const FormSwitch = (fieldRenderProps, label, defaultCheck) => {
    const { validationMessage, visited, disabled, ...others } = fieldRenderProps;

    return (
      <div>
        <Switch disabled={disabled} defaultChecked={defaultCheck} {...others} />
        <label
          style={{ paddingLeft: '10px' }}
          className="k-checkbox-label">
          {label}
        </label>
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    );
  }

  const FormSelect = (fieldRenderProps, setSelectState) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
    const regex = new RegExp(expression);
    let bool = checkRan
    if (props.item.tokenUrl) {
      bool = (props.item.tokenUrl.match(regex));
    }

    return (
      <div>
        <DropDownList
          textField={'name'}
          dataItemKey={'name'}
          data={bool ? esriFields : []} {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    )
  }

  const defaultFormSwitch = (fieldRenderProps) => {
    return FormSwitch(fieldRenderProps, "Default Layer", props.item.defaultLayer)
  }

  return <Dialog
    title={props.item.id ? `Edit Layer` : `Create Layer`}
    style={{ zIndex: 2 }}
    onClose={props.cancelEdit}
  >
    <Form
      style={{ maxHeight: '600px', minWidth: '500px' }}
      onSubmit={(e) => submit(e, props)}
      initialValues={props.item}
      ignoreModified={true}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"}>
            <div style={{ height: '460px', paddingRight: '10px', overflowY: 'scroll' }}>
              <div style={styles.accountDiv}>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"name"} defaultValue={props.item?.name} component={FormStringInput} label={"Layer Name"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"url"} defaultValue={props.item?.url} component={FormStringInput} label={"URL"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"tokenUrl"} defaultValue={props.item?.tokenUrl} component={FormStringInput} label={"Token URL"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"tokenUsername"} defaultValue={props.item?.tokenUsername} component={FormStringInput} label={"Token Username"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"tokenPassword"} defaultValue={props.item?.tokenPassword} component={FormStringInput} label={"Token Password"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"attribute1"} defaultValue={{ name: props.item?.attribute_1 }} component={FormSelect} label={"Attribute 1"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"attribute2"} defaultValue={{ name: props.item?.attribute_2 }} component={FormSelect} label={"Attribute 2"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"attribute3"} defaultValue={{ name: props.item?.attribute_3 }} component={FormSelect} label={"Attribute 3"} />
                </div>
                {/*<div className="mb-3" style={styles.formField}>
                  <Field name={"attribute1Label"} defaultValue={props.item?.attribute1Label} component={FormStringInput} label={"Token Password"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"attribute2Label"} defaultValue={props.item?.attribute2Label} component={FormStringInput} label={"Token Password"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"attribute3Label"} defaultValue={props.item?.attribute3Label} component={FormStringInput} label={"Token Password"} />
                </div>*/}
                <div className="mb-3" style={styles.formField}>
                  <Field name={"Groups"} component={FormMultiSelect} label={"Groups"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field
                    name={"defaultLayer"}
                    component={defaultFormSwitch}
                    label={"Default Layer"} />                
                </div>
              </div>
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end" style={{ paddingBottom: '10px' }}>
            <button onClick={(e) => {e.preventDefault();fetchFields(formRenderProps.valueGetter)}} className="k-button k-primary" style={styles.modalBtn} disabled={false}>
                Check
            </button>
            <button type={"submit"} className="k-button k-primary" style={styles.modalBtn} disabled={false}>
              Save
            </button>
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog>
}

const styles = {
  formElement: {
    minWidth: 465,
    maxHeight: 525,
    minHeight: 525
  },
  formField: {
    marginTop: 10,
    marginBottom: 25,
  },
  formFieldButton: {
    marginTop: 10,
    marginBottom: 25,
    textAlign: 'center',
  },
  formLabel: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  adminSection: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row'
  },
  modalBtn: {
    padding: '10px 15px'
  },
  accountDiv: {
    backgroundColor: '#F5F5F5',
    padding: '8px',
    border: '2px solid #DCDCDC',
    borderRadius: '6px'
  }
  //    padding: 8px 24px;
}

export default EditLayerForm;